import React from 'react';
// @mui
import { FormControl, SxProps, Autocomplete, TextField } from '@mui/material';

interface CurrencySelectorProps {
  currencies: string[];
  currency: string;
  selectedCurrency: (newCurrency: string) => void;
  onClick?: (newCurrency: string) => void;
  sx?: SxProps;
  disabled?: boolean;
  size?: 'small' | 'medium';
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({
  currencies,
  currency,
  selectedCurrency,
  onClick,
  sx,
  disabled,
  size = 'small'
}) => {

  const onChangeCurrency = (currency: string) => {
    if (currency) {
      selectedCurrency(currency);
      onClick && onClick(currency);
    }
  };

  return (
        <FormControl sx={{ ...sx }}>
          <Autocomplete
            disabled={disabled}
            disablePortal
            disableClearable
            options={currencies}
            sx={{ minWidth: 120 }}
            renderInput={(params) => (
              <TextField {...params} label="Currency" sx={{ '& > div': { width: '100% !important' } }} />
            )}
            ListboxProps={{ style: { maxHeight: 250 } }}
            value={currency}
            onChange={(event: any, newValue: string | null) => {
              onChangeCurrency(newValue as any);
            }}
            size={size}
          />
        </FormControl>
  );
};

export default CurrencySelector;
